import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { shortCourseCheckoutActions } from './short-course-checkout.actions';
import { shortCourseCheckoutMutations } from './short-course-checkout.mutations';
import { shortCourseCheckoutState } from './short-course-checkout.state';

export default {
  namespaced: true,
  state: shortCourseCheckoutState,
  actions: shortCourseCheckoutActions,
  mutations: shortCourseCheckoutMutations
} as ModuleTree<RootState>;
